<button
  [attr.type]="type()"
  [disabled]="disabled() || loading()"
  [attr.aria-busy]="loading() ? 'true' : null"
  [attr.aria-disabled]="disabled() || loading() ? 'true' : null"
  [attr.aria-label]="ariaLabel() || null"
  [attr.aria-expanded]="ariaExpanded() ?? null"
  class="ui-button"
  [class.ui-button--primary]="variant() === 'primary'"
  [class.ui-button--secondary]="variant() === 'secondary'"
  [class.ui-button--white]="variant() === 'white'"
  [class.ui-button--ghost]="variant() === 'ghost'"
  [class.ui-button--danger]="variant() === 'danger'"
  [class.ui-button--icon]="variant() === 'icon'"
  [class.ui-button--icon-square]="
    variant() === 'icon' && iconShape() === 'square'
  "
  [class.ui-button--icon-circle]="
    variant() === 'icon' && iconShape() === 'circle'
  "
  [class.ui-button--icon-blue]="
    variant() === 'icon' && iconBackground() === 'blue'
  "
  [class.ui-button--icon-white]="
    variant() === 'icon' && iconBackground() === 'white'
  "
  [class.ui-button--document]="variant() === 'document'"
  [class.ui-button--sm]="size() === 'sm'"
  [class.ui-button--md]="size() === 'md'"
  [class.ui-button--lg]="size() === 'lg'"
  [class.ui-button--loading]="loading()"
  (click)="onClick($event)"
>
  @if (loading()) {
    <span class="ui-button__spinner" aria-hidden="true"></span>
    <span class="ui-button__loading-label">{{ loadingLabel() }}</span>
  }
  <span
    class="ui-button__content"
    [class.ui-button__content--hidden]="loading()"
  >
    @if (variant() === 'document' && iconSrc()) {
      <img class="ui-button__document" [src]="iconSrc()" alt="" />
    } @else if (iconSrc()) {
      <span
        class="ui-button__icon"
        [style.mask-image]="'url(' + iconSrc() + ')'"
        [style.webkitMaskImage]="'url(' + iconSrc() + ')'"
        aria-hidden="true"
      ></span>
    }
    <span class="ui-button__label">
      <ng-content />
    </span>
  </span>
</button>
